export const isUpKey = (key: string) =>
  key === "ArrowUp" || key === "w" || key === "k";

export const isRightKey = (key: string) =>
  key === "ArrowRight" || key === "d" || key === "l";

export const isLeftKey = (key: string) =>
  key === "ArrowLeft" || key === "a" || key === "h";

export const isDownKey = (key: string) =>
  key === "ArrowDown" || key === "s" || key === "j";
